import localforage from 'localforage';
import { StickerFormatEnum } from '../enums/StickerFormatEnum';
import * as _ from "lodash";

class StickerCache {
  cacheMediaAsBlob(stickerState, media) {
    const stickerItemId = stickerState.scannedSticker.sticker_id;

    let mediaCopy = _.cloneDeep(media);
    const stickerFormat = stickerState.form.format;
    const convertingBlobPaths: string[] = [];
    switch(stickerFormat){
      case StickerFormatEnum.Video:
        convertingBlobPaths.push('resultPreviewBlob', 'resultVideoBlob');
        break;
      case StickerFormatEnum.Image:
        convertingBlobPaths.push('originPhotoInfo.blob', 'resultPhotoInfo.blob');
        break;
      case StickerFormatEnum.Audio:
        convertingBlobPaths.push('originAudioBlob');
        break;
    }

    this.convertBlobsToBufferedArray(convertingBlobPaths, mediaCopy)
      .then((arrayBuffersList: any) => {
      arrayBuffersList.forEach((v, i) => {
        const exifdata = _.get(media, convertingBlobPaths[i]).exifdata;
        _.set(mediaCopy, convertingBlobPaths[i], { arrayBuffer: v, exifdata });
      });
      localforage.getItem(stickerItemId)
        .then((sticker: any) => {
          if (sticker) {
            sticker.media = mediaCopy;
            Object.assign(sticker, { stickerState, location: '/new/theme' });
            localforage.setItem(stickerItemId, sticker);
          } else {
            localforage.setItem(stickerItemId, { media: mediaCopy, stickerState, location: '/new/theme' });
          }
        })
        .catch(() => {
          localforage.setItem(stickerItemId, { media: mediaCopy, stickerState, location: '/new/theme' });
        })
      })
  }

  private convertBlobsToBufferedArray = (convertingBlobPaths, media) => {
    return new Promise((res, rej) => {
      const reader = new FileReader();
      let index = 0;
      const arrayBuffersList: ArrayBuffer[] = [];
      reader.addEventListener("loadend", function(e: any) {
        arrayBuffersList.push(e.target.result);

        if (_.get(media, convertingBlobPaths[index])) {
          reader.readAsArrayBuffer(_.get(media, convertingBlobPaths[index++]));
        } else {
          return res(arrayBuffersList);
        }
      });
      reader.readAsArrayBuffer(_.get(media, convertingBlobPaths[index++]));
    });
  };

  cacheTheme(stickerState) {
    const stickerId = stickerState.scannedSticker.sticker_id;
    localforage.getItem(stickerId)
      .then((sticker) => {
        Object.assign(sticker, { stickerState, location: '/new/message' });
        localforage.setItem(stickerId, sticker);  
      })
      .catch(() => {
        localforage.setItem(stickerId, { stickerState, location: '/new/message' });  
      })
  }
  cacheMessage(stickerState) {
    const stickerId = stickerState.scannedSticker.sticker_id;
    localforage.getItem(stickerId)
      .then((sticker) => {
        Object.assign(sticker, { stickerState, location: '/new/preview'  });
        localforage.setItem(stickerId, sticker);  
      })
      .catch(() => {
        localforage.setItem(stickerId, { stickerState, location: '/new/preview' });  
      })
  }

  cacheUploadedMedia(stickerState, uploadedMedia) {
    const stickerId = stickerState.scannedSticker.sticker_id;
    localforage.getItem(stickerId)
      .then((sticker) => {
        Object.assign(sticker, { uploadedMedia });
        localforage.setItem(stickerId, sticker);  
      })
      .catch(() => {
        localforage.setItem(stickerId, { uploadedMedia });
      })
  }

  getCachedSticker(stickerId: string) {
    return localforage.getItem(stickerId);
  }

  removeCachedSticker(stickerId) {
    return localforage.removeItem(stickerId);
  }
}
const cacheManager = new StickerCache();

export default cacheManager;



// WEBPACK FOOTER //
// ./src/app/modules/stickers/domain/services/StickerCache.ts